import { fontSizes } from '../../constants/constants.js';
import FundReportsFunctional from './index.function.js';
import Text from '../../components/Text.jsx';
import ViewReverse from '../../components/ViewReverse.jsx';
import { fundsCustomerStatements } from '../../config/config.js';
import { CardView } from './component';
import CustomTable from '../../components/CustomTable.jsx';
import { Dropdown } from '../../components';
import LoaderModal from '../../components/LoaderModal.jsx';

const FundCustomerStatements = () => {
  const {
    TextWeight,
    isArabic,
    getContentKey,
    direction,
    selectedFunds,
    my_funds,
    onPressFund,
    investment_statements,
    fund_loading,
    investment_loading,
    onPressDownload
  } = FundReportsFunctional();

  const top_cards_array = [
    {
      label: "nav",
      key: "nav",
      value: investment_statements?.fund?.nav,
    },
    {
      label: "shares_held",
      key: "sharesHeld",
      value: investment_statements?.investment?.holding_units,
    },
    {
      label: "cost_holding",
      key: "costOfHolding",
      value: investment_statements?.investment?.holding_cost,
      isSymbol: true
    },
    {
      label: "current_market_value",
      key: "currentMarketValue",
      value: investment_statements?.investment?.current_market_value,
      isSymbol: true
    },
    {
      label: "current_unrealized",
      key: "currentUnrealized",
      value: investment_statements?.investment?.current_unrealized_amount,
      isSymbol: true
    },
  ];

  return (
    <div>
      <ViewReverse
        className={'mb-3 sm:mb-5 justify-between flex-wrap items-center'}
      >
        <Text
          text={getContentKey('heading')}
          size={fontSizes.h20}
          weight={TextWeight.bold}
          isTruncate={false}
          color='text-black'
        />
        <ViewReverse className='gap-3 w-full md:w-4/12'>
          <Dropdown
            selectedValue={selectedFunds}
            valueKey={'fundName'}
            options={my_funds?.fundMaster}
            onSelect={(val) => onPressFund(val)}
            isRequired={true}
            menuClasses={'top-9'}
            weight={TextWeight.medium}
          />
        </ViewReverse>
      </ViewReverse>
      {
        !selectedFunds && <Text size={fontSizes.h18} weight={TextWeight.medium} color={'text-primary'} className={"mt-12"} isCenter text={getContentKey('please_select_statement')} />
      }
      {
        selectedFunds && (
          investment_statements?.transactions?.length > 0 ?
            <>
              <div
                className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-7'
                dir={direction}
              >
                {top_cards_array?.map((item) => (
                  <CardView
                    key={item.key}
                    title={`${getContentKey(item?.label)}${investment_statements?.fund?.manual_nav_date ? `${getContentKey("on")} ${investment_statements?.fund?.manual_nav_date}` : ""}`}
                    amount={item?.value}
                    isSymbol={item?.isSymbol}
                  />
                ))}
              </div>
              <CustomTable
                headCells={
                  isArabic
                    ? fundsCustomerStatements(getContentKey)?.reverse()
                    : fundsCustomerStatements(getContentKey)
                }
                onPressDownload={onPressDownload}
                isbutton={false}
                isOpen
                isBorder={false}
                loading={false}
                isDownloading={true}
                data={investment_statements?.transactions?.map((item, index) => ({
                  ...item,
                  id: index + 1,
                }))}

              />
            </>
            :
            <Text
              text={getContentKey('no_statements_found')}
              size={fontSizes.h16}
              isCenter
              className={'mt-12'}
            />
        )
      }

      <LoaderModal open={fund_loading || investment_loading} />
    </div>
  );
};

export default FundCustomerStatements;
